import { render } from "./APagination.vue?vue&type=template&id=78ff8e77"
import script from "./APagination.vue?vue&type=script&lang=js"
export * from "./APagination.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__